/**
* @name APP parvulo
* @description
* # name controller --> modalPowerBiController
* # As Controller --> modalPowerBi														
*/
export default class modalPowerBiController {
    constructor($scope, $state, $rootScope,$modalInstance,UserInfoConstant,ngNotify, SERVICE_URL_CONSTANT, variableAEnviar) {
	    this.$scope = $scope
	    this.$state = $state
	    this.ngNotify = ngNotify
	    this.$rootScope = $rootScope
		this.baseUrl = SERVICE_URL_CONSTANT
		this.$modalInstance = $modalInstance
		const key = {
			1 : 'Indicadores de Aprendizaje',
			2 : 'Estudiantes'
		}
		this.nameBi = key[variableAEnviar.type_bi]
		this.type_bi = variableAEnviar.type_bi
		this.levelId = variableAEnviar.level
		this.$scope.UserInfoConstant = UserInfoConstant
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.main()
			}
		})
    }

	main() {
		this.params = {
			concept_id: this.conceptId
		}
	}

	cancel() {
		// this.$state.reload('app.minorHalf')
		this.$modalInstance.dismiss('chao');
	}
  }

  modalPowerBiController.$inject = ['$scope', '$state','$rootScope','$modalInstance','UserInfoConstant','ngNotify', 'SERVICE_URL_CONSTANT', 'variableAEnviar'];



// WEBPACK FOOTER //
// ./src/app/course-front/modal-power-bi/modalPowerBiController.js